import { getRoute } from '@/router/paths';

const notification = new Audio(getRoute('/audio/notifications/notification.mp3'));

export default notification;
